// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_benefit3_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Active muscles correct your alignment — no rigid supports needed.`
};

const el_tech_benefit3_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Οι ενεργοί μύες διορθώνουν τη στάση σας — χωρίς άκαμπτα στηρίγματα.`
};

const ru_tech_benefit3_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Активные мышцы корректируют положение тела — без жёстких ортопедических вставок.`
};

const he_tech_benefit3_detail = /** @type {(inputs: {}) => string} */ () => {
	return `שרירים פעילים מתקנים את היציבה — ללא תמיכות נוקשות.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_benefit3_detail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_benefit3_detail(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_benefit3_detail", locale)
	if (locale === "en") return en_tech_benefit3_detail(inputs)
	if (locale === "el") return el_tech_benefit3_detail(inputs)
	if (locale === "ru") return ru_tech_benefit3_detail(inputs)
	if (locale === "he") return he_tech_benefit3_detail(inputs)
	return "tech_benefit3_detail"
};